import React, { useContext, useEffect, useRef, useState } from 'react'
import "./editPastMeeting.css"
import { useNavigate } from "react-router-dom";

// ----------------------------------------------------------------------------Packages---------------------------------------------------------------------------
import { ReactMultiEmail, isEmail } from "react-multi-email";
import FileUpload from '../../../../Other/FileUpload';
import DatePicker from "react-datepicker";
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import moment from 'moment';
// ----------------------------------------------------------------------------Icons---------------------------------------------------------------------------
import { AiOutlineClose, AiOutlineDelete, AiOutlinePlus, AiOutlineRight } from 'react-icons/ai';
import { IoCloudUpload } from "react-icons/io5";

import { Url } from '../../../../../constants/ApiUrlConstants';
import { contextData } from '../../../../../context/ContextProvider';
import { useLocation } from 'react-router-dom';
import { GET, POST } from '../../../../Common/HttpMethods/HttpMethods';
import SuccessModal from "../../../../Common/Popups/SuccessModal";
import FailModal from "../../../../Common/Popups/FailModal";
import { NumberCellEditor } from 'ag-grid-community';
import Select from "react-select";
import CreatableSelect from "react-select/creatable";
import { MdOutlineWatchLater } from "react-icons/md";
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import { Cuurent_EMAIL, Cuurent_USER_ROLES, Cuurent_USERNAME, getEmailClassification, nearestTime, stripHtmlTags } from '../../../../CommonCase/CommonFunctions';


export function timeDifference(time1, time2) {
    function timeToMinutes(timeStr) {
        if (typeof timeStr !== "string") {
            console.error("Invalid input to timeToMinutes:", timeStr);
            return 0; // Return a default value
        }
        let [time, period] = timeStr.split(" ");
        let [hours, minutes] = time.split(":").map(Number);
        if (period === "PM" && hours !== 12) {
            hours += 12;
        } else if (period === "AM" && hours === 12) {
            hours = 0;
        }
        return hours * 60 + minutes;
    }

    

    function minutesToTime(minutes) {
        let hours = Math.floor(minutes / 60);
        let mins = minutes % 60;
        return `${String(hours).padStart(2, '0')}h:${String(mins).padStart(2, '0')}m`;
    }

    let minutes1 = timeToMinutes(time1);
    let minutes2 = timeToMinutes(time2);

    // Calculate difference
    let diffMinutes = minutes2 - minutes1;

    // Adjust for negative difference
    if (diffMinutes < 0) {
        diffMinutes += 24 * 60;
    }

    return minutesToTime(diffMinutes);
}

export const transformText = (text) => {
    return text ? text.split('\n').join('<br/>') : '';
};

export function addMoreHalfHours(inputTime) {
    const format = 'hh:mm A';

    // Parse the input time using moment
    const parsedTime = moment(inputTime, format);

    // Add 30 minutes to the parsed time
    const resultTime = parsedTime.add(30, 'minutes');

    // Format and return the result
    return resultTime.format(format);
}

export function handleCreateOption(inputTime, type, momData, setMomData, setFailMessage, setOpenFailModal) {
    // const { momData, setMomData, setFailMessage, setOpenFailModal } = dependencies;

    let regEx = /^(?:1[0-2]|0?[1-9]):[0-5][0-9] (AM|PM)$/;
    if (regEx.test(inputTime)) {
        let addedHalfHour = addMoreHalfHours(inputTime);
        if (type === "startTime") {
            let timeDiff = timeDifference(inputTime, addedHalfHour);
            setMomData({ ...momData, startTime: inputTime, endTime: addedHalfHour, duration: timeDiff });
        } else if (type === "endTime") {
            let timeDiff1 = timeDifference(momData?.startTime, inputTime);
            setMomData({ ...momData, endTime: inputTime, duration: timeDiff1 });
        }
    } else {
        setFailMessage("Invalid Time");
        setOpenFailModal(true);
    }
}

export const getMeetingData = async ({ setLoading,
    location,
    setFromObject,
    setAttendeesData,
    attendeesData,
    setOptions,
    setActualData,
    setMomData,
    setSessionExpiredModal,
    setFailMessage,
    setOpenFailModal
}) => {
    setLoading(true);
    const token = sessionStorage.getItem("TOKEN");
    const meetingResponse = await GET(Url.GetMeetingMomByMeetingId.replace('{meetingId}', `${location?.state?.meetingId}`).replace("{isAttendeeRequired}", "Y"), token);
    if (meetingResponse?.SUCCESS) {
        // const { mid, meetingSummary, meetingAgenda, emailDetails, appointmentRecurrence, recordedByName, momRecordedBy, actionItems, attachmentDocuments, meetingSubject, meetingLocation, startDate, endDate, startTime, endTime, duration, isAllDay, momVersion, editViewMomVersion } = meetingResponse.DATA;
        const {
            mid,
            meetingSubject,
            meetingLocation,
            startDate,
            endDate,
            parseStartDate,
            parseEndDate,
            startTime,
            endTime,
            duration,
            message,
            momRecordedBy,
            meetingAgenda,
            meetingSummary,
            momStatus,
            momVersion,
            editViewMomVersion,
            actionItems,
            attachmentDocuments,
            isAllDay,
            participantsList,
            emailDetail
        } = meetingResponse.DATA;;

        console.log({
            mid,
            meetingSubject,
            meetingLocation,
            startDate,
            endDate,
            parseStartDate,
            parseEndDate,
            startTime,
            endTime,
            duration,
            message,
            momRecordedBy,
            meetingAgenda,
            meetingSummary,
            momStatus,
            momVersion,
            editViewMomVersion,
            actionItems,
            attachmentDocuments,
            participantsList,
            emailDetail,
            isAllDay
        });




        const { to, from, optional } = getEmailClassification(emailDetail);




        let optionalToArr = Array.isArray(to) ? to.map(item => ({
            label: item?.employeeMaster?.fullName,
            value: item
        })) : [];

    

        let optionalFromArr = Array.isArray(emailDetail) ? emailDetail
            .filter(item => item.isMomSender === "Y")
            .map(item => ({
                label: item?.employeeMaster?.fullName,
                value: item
            })) : [];



        let optionalArr = Array.isArray(optional) ? optional.map((item) => ({
            label: item?.employeeMaster?.fullName,
            value: item
        })) : [];

        let emailArrays = [...to, ...from, ...optional]
        setFromObject(emailArrays);

        const attendeesArr = emailDetail;
        const dummyAttendees = [];

        setAttendeesData(emailDetail)


        if (attendeesArr) {
            attendeesArr.forEach(item => {
                if (item.isAttendee === "Y") {
                    dummyAttendees.push({
                        label: item?.employeeMaster?.fullName,
                        value: {
                            emailDetailId: item.emailDetailId,
                            isMomSender: item.isMomSender,
                            isAttendee: item.isAttendee,
                            participantEmail: item.participantEmail,
                            emailTypeMaster: item.emailTypeMaster,
                            employeeMaster: item.employeeMaster
                        }
                    });
                }
            });
        }


        // Now dummyAttendees array contains only objects where isAttendee is "Y"



        const startDateConverted = `${startDate[0]}-${startDate[1]}-${startDate[2]}`
        let actuleFileData = [];
        let editFileData = [];

        attachmentDocuments?.map((f) => {
            actuleFileData.push({
                name: f.fileName,
                fileType: f.fileType,
                attachment: f.attachment,
                attachmentDocId: f.attachmentDocId
            });

            editFileData.push({
                fileName: f.fileName,
                fileType: f.fileType,
                attachment: f.attachment,
                attachmentDocId: f.attachmentDocId
            });
        });

            console.log("attendeesData12121212", attendeesData)
        let opt = emailDetail?.map((i) => {
            return { ...i?.employeeMaster, label: i?.employeeMaster?.fullName, value: i?.employeeMaster?.staffId }
        })
        console.log("opt1212121",opt)
        setOptions(opt)

        setActualData([...actuleFileData])
        setMomData({
            "mid": mid,
            "emailDetailId": !emailDetail || !emailDetail[0] ? "" : emailDetail[0]?.emailDetailId,
            "emailfrom": optionalFromArr,
            "momSenderEmail": emailDetail && emailDetail[0] ? emailDetail[0]?.isMomSender == "Y" ? emailDetail?.participantEmail : "" : "",
            "emailto": optionalToArr,
            "emailoptional": optionalArr,
            "attendees": !dummyAttendees ? [] : dummyAttendees,
            "actionItems": !actionItems ? [] : actionItems,
            "attachmentDocuments": !attachmentDocuments ? [] : [...editFileData],
            "meetingAgenda": !meetingAgenda ? "" : meetingAgenda,
            "meetingSummary": !meetingSummary ? "" : meetingSummary,
            "meetingSubject": !meetingSubject ? "" : meetingSubject,
            "meetingLocation": meetingLocation?.location,
            "startDate": new Date(startDateConverted),
            "endDate": new Date(`${endDate[0]}-${endDate[1]}-${endDate[2]}`),
            "startTime": !startTime ? "" : (isAllDay == "Y" ? "12:00 AM" : startTime),
            "endTime": !endTime ? "" : (isAllDay == "Y" ? "12:00 AM" : endTime),
            "duration": !duration ? "0" : duration,
            "recordedBy": !momRecordedBy?.fullName ? "" : momRecordedBy?.fullName,
            "momVersion": !momVersion ? "" : momVersion,
            "editViewMomVersion": !editViewMomVersion ? "NA" : editViewMomVersion,
            "isAllDay": isAllDay == "Y" ? true : false,
            "emailDetail": emailDetail
        })
        // setLoading(false);

        return meetingResponse;
    }
    else if (meetingResponse?.STATUS == 401) {
        setLoading(false)
        setSessionExpiredModal(true)
        setFailMessage("Session expired")
    }else if (meetingResponse?.STATUS == 400) {
        setLoading(false)
        setSessionExpiredModal(true)
        setFailMessage("Session expired")
    }else if (meetingResponse?.STATUS == 403) {
        setLoading(false)
        setSessionExpiredModal(true)
        setFailMessage("Session expired")
    }else if (meetingResponse?.STATUS == 404) {
        setLoading(false)
        setSessionExpiredModal(true)
        setFailMessage("Session expired")
    }else if (meetingResponse?.STATUS == 500) {
        setLoading(false)
        setSessionExpiredModal(true)
        setFailMessage("Session expired")
    }
    else {
        setLoading(false);
        setFailMessage("Failed to fetch minutes.")
        setOpenFailModal(true)

    }
}

export const fetchAllDropDownData = async (data, {
    setLoading, setSessionExpiredModal, setFailMessage, setOpenFailModal,
    setFilteredToEmployeeData, setFilteredOptionalEmployeeData, GET, Url, token, Email, getEmailClassification
}) => {
    setLoading(true);
    try {
        const employeesDataResponse = await GET(Url.getEmployees, token);
        if (employeesDataResponse.SUCCESS) {
            let nd = employeesDataResponse.DATA.map(item => ({ label: item.fullName, value: item }));
            let FromEmail = data.DATA.emailDetail.find(item => item.emailTypeMaster?.emailType === "From")?.participantEmail;
            let AllDataWithoutFrom = nd.filter(i => i.value.emailId !== FromEmail);
            let fromToValues = getEmailClassification(data.DATA.emailDetail);
            let AllExsistingMails = [...fromToValues.to, ...fromToValues.from, ...fromToValues.optional].map(item => item.participantEmail);
            let DataWithoutExsistingEmails = nd.filter(i => !AllExsistingMails.includes(i.value.emailId));

            setFilteredToEmployeeData(DataWithoutExsistingEmails);
            setFilteredOptionalEmployeeData(AllDataWithoutFrom);
        } else if (employeesDataResponse.STATUS === 401) {
            setSessionExpiredModal(true);
            setFailMessage("Session expired");
        }  else if (employeesDataResponse.STATUS === 400) {
            setSessionExpiredModal(true);
        } else if (employeesDataResponse.STATUS === 403) {
            setSessionExpiredModal(true);
        } else if (employeesDataResponse.STATUS === 404) {
            setSessionExpiredModal(true);
        } else if (employeesDataResponse.STATUS === 500) {
            setSessionExpiredModal(true);
        } else {
            setLoading(false);
        }
    } catch (error) {
        setLoading(false);
        setFailMessage("Failed to fetch minutes.");
        setOpenFailModal(true);
    }
};

export const handleSelectAttendee = (
    indexToSelect,
    attendeesData,
    setAttendeesData,
    validateInput,
    setPreventFirst, 
    setFormErrors, 
    handleChange, 
    tablerow
) => {
    const updatedAttendees = attendeesData.map((item, index) => {
        if (index === indexToSelect) {
            return {
                ...item,
                isAttendee: item.isAttendee === "Y" ? "N" : "Y"
            };
        } else {
            return item;
        }
    });

    setAttendeesData(updatedAttendees);
    const selectedAttendees = updatedAttendees.filter((item) => item.isAttendee === "Y");
    validateInput("attendees", selectedAttendees, setFormErrors, handleChange, tablerow);
    setPreventFirst(true);
};

export const handleSelectAllAttendees = (
    attendeesData,
    setAttendeesData,
    validateInput,
    setPreventFirst, setFormErrors, handleChange, tablerow
) => {
    const allSelected = attendeesData.every(item => item.isAttendee === "Y");

    const updatedAttendees = attendeesData.map(item => ({
        ...item,
        isAttendee: allSelected ? "N" : "Y"
    }));

    setAttendeesData(updatedAttendees);

    const selectedAttendees = updatedAttendees.filter(item => item.isAttendee === "Y");

    validateInput("attendees", selectedAttendees, setFormErrors, handleChange, tablerow);
    setPreventFirst(true);
};


export const handleAddRow = (fieldName, e, tablerow, setTablerow) => {
    const value = e.target ? e.target.value : e;
    setTablerow((prevState) => {
        if (fieldName === "taskName") {
            return { ...prevState, [fieldName]: value.substring(0, 1).toUpperCase() + value.substring(1) };
        }
        return { ...prevState, [fieldName]: value };
    });
};

export const handleDeleteRow = (id, setMomData, momData) => {
    setMomData((prevState) => {
        const updatedActionItems = prevState.actionItems?.filter((_, index) => index !== id);

        return {
            ...prevState,
            actionItems: updatedActionItems
        };
    });
};

export const handleEditClosingDate = (name, date, itemIndex, momData, setMomData) => {
    let updatedClosing = momData?.actionItems?.map((item, index) => {
        if (itemIndex === index) {
            return { ...item, closingDate: date };
        } else {
            return item;
        }
    });
    setMomData((prevState) => ({ ...prevState, actionItems: updatedClosing }));
};


export const handleCheckboxChange = (
    option,
    setTempCheckedValues,
    setTablerow,
    options,
    addNewActionItemClicked
) => {
    setTempCheckedValues(prevCheckedValues => {
        const isChecked = prevCheckedValues.includes(option.emailId);

        const updatedCheckedValues = isChecked
            ? prevCheckedValues.filter(id => id !== option.emailId)
            : [...prevCheckedValues, option.emailId];

        let newAssignedToList = [];

        setTablerow(prevTablerow => {
            newAssignedToList = addNewActionItemClicked
                ? options.filter(opt => updatedCheckedValues.includes(opt.emailId))
                : isChecked
                    ? prevTablerow.assignedToList.filter(item => item.emailId !== option.emailId)
                    : [...prevTablerow.assignedToList, option];

            return {
                ...prevTablerow,
                assignedToList: newAssignedToList,
            };
        });

        return updatedCheckedValues;
    });
};

// utils.js (or any suitable file)
export const validateInput = (
    name,
    value,
    setFormErrors,
    handleChange,
    tablerow
) => {
    let field = name;
    let errorMessage = "";

    switch (name) {
        case "emailfrom":
            if (!value) {
                errorMessage = "This field is required.";
            }
            break;

        case "emailto":
            if (value?.length === 0) {
                errorMessage = "This field is required.";
            }
            break;

        case "attendees":
            if (value?.length === 0) {
                errorMessage = "Attendees are required.";
            }
            break;

        case "meetingSummary":
            if (/^\s/.test(value) || value === "") {
                errorMessage = "Input cannot have leading whitespace or be empty.";
            }
            break;

        case "actionItems":
            if (Array.isArray(value) && value?.length == 0) {
                errorMessage = "Action Items are required.";
            }
            else if (typeof (value) == "object" && Object.keys(value).includes("taskName")) {
                console.log("actionItems actionItems value", value)
                const { taskName, ownerName, etaDate, closingDate, assignedToList } = value;
                if (!taskName  || !etaDate) {
                    errorMessage = "All fields are required."
                } else if (/^\s/.test(taskName) || taskName === "") {
                    errorMessage = "Input cannot have leading whitespace or be empty.";
                }  else {
                    handleChange("actionItems", tablerow);
                }
            }
            break;
            // case "actionItemsLength":
            //     if (momData?.actionItems?.length === 0) {
            //         errorMessage = "Action Items are required.";
            //     }
        default:
            errorMessage = "";
            field = "";
    }

    setFormErrors((prevState) => ({ ...prevState, [name]: errorMessage }));
    return errorMessage;
};


export const handleSessionExpClose = (navigate,setActive) => {
    sessionStorage.clear();
    navigate('/login');
    setActive('tab1');
}

// Handle emailto changes
export const handleEmailToChange = (value, momData, setMomData, filteredOptionalEmployeeData, setFilteredToEmployeeData) => {
    const consolitatedValue = value?.map((item) => ({
        label: item?.label,
        value: {
            emailDetailId: item?.value?.emailDetailId || 2,
            isMomSender: item?.value?.isMomSender || "N",
            isAttendee: item?.value?.isAttendee ? item.value.isAttendee : "N",
            participantEmail: item?.value?.participantEmail ? item?.value?.participantEmail : item?.value?.emailId,
            emailTypeMaster: { 
                emailTypeId: 2, 
                emailType: "To" 
            }
        }
    }));

    setMomData((prevState) => ({ ...prevState, emailto: [...consolitatedValue] }));

    let emps = []

                value.map((i) => {
                    emps.push(i?.value?.emailId);
                    return null;
                });

                momData?.emailoptional?.map((i) => {
                    emps.push(i?.value?.emailId);
                    return null;
                });


                let empList = filteredOptionalEmployeeData?.filter((i) => {
                    return !emps?.includes(i.value.emailId)
                })
                setFilteredToEmployeeData(empList);
};

// Handle emailoptional changes
export const handleEmailOptionalChange = (value, momData, setMomData, filteredOptionalEmployeeData, setFilteredToEmployeeData) => {
    const consolsValue = value?.map((item) => ({
        label: item?.label,
        value: {
            emailDetailId: item?.value?.emailDetailId || 3,
            isMomSender: item?.value?.isMomSender || "N",
            isAttendee: item?.value?.isAttendee ? item.value.isAttendee : "N",
            participantEmail: item?.value?.participantEmail ? item?.value?.participantEmail : item?.value?.emailId,
            emailTypeMaster: { emailTypeId: 3, emailType: "Cc/Optional" }
        }
    }));

    setMomData((prevState) => ({ ...prevState, emailoptional: [...consolsValue] }));

    let emps1 = []

    value.map((i) => {
        emps1.push(i?.value?.emailId);
        return null;
    });

    momData?.emailto?.map((i) => {
        emps1.push(i?.value?.emailId);
        return null;
    });


    let empList1 = filteredOptionalEmployeeData?.filter((i) => {
        return !emps1?.includes(i.value.emailId);
    });

    setFilteredToEmployeeData(empList1);
};

// Handle emailto removal
export const handleEmailToRemove = (value, momData, setMomData) => {
    let emailsTo = momData?.emailto?.filter((i, index) => index !== value);
    setMomData((prevState) => ({ ...prevState, emailto: [...emailsTo] }));
};

// Handle emailoptional removal
export const handleEmailOptionalRemove = (value, momData, setMomData) => {
    let emailsOptional = momData?.emailoptional?.filter((i, index) => index !== value);
    setMomData((prevState) => ({ ...prevState, emailoptional: [...emailsOptional] }));
};

// Handle attachmentDocuments changes
export const handleAttachmentDocumentsChange = (value, momData, setMomData) => {
    setMomData((prevState) => ({ ...prevState, attachmentDocuments: [...prevState.attachmentDocuments, ...value] }));
};

// Handle actionItems changes
export const handleActionItemsChange = (value, setTablerow, setAddNewActionItemClicked, momData, setMomData) => {

    console.log("handleActionItemsChange", handleActionItemsChange)

    setMomData((prevState) => ({ ...prevState, actionItems: [...prevState.actionItems, value] }));
    setTablerow({
        actionItemId: null,
        taskName: "",
        ownerName: "",
        etaDate: "",
        closingDate: "",
        assignedTo: null,
        assignedToList: []
    });
    setAddNewActionItemClicked(false);
};

// Handle startTime changes
export const handleStartTimeChange = (value, momData, setMomData, TimeArray, timeDifference) => {
    let et = TimeArray?.indexOf(value.value) === TimeArray?.length - 1 ? TimeArray[0] : TimeArray[TimeArray.indexOf(value.value) + 1];
    let time_d = timeDifference(value.value, et);
    setMomData({ ...momData, startTime: value.value, endTime: et, duration: time_d });
};

// Handle endTime changes
export const handleEndTimeChange = (value, momData, timeDifference, setMomData) => {
    let time_diff = timeDifference(momData?.startTime, value?.value);
    setMomData({ ...momData, endTime: value?.value, duration: time_diff });
};

// Handle default changes
export const handleDefaultChange = (name, value, setMomData) => {
    setMomData((prevState) => ({ ...prevState, [name]: value }));
};


const convertToConsolidatedFormat = (array, emailType, nonAttendees) => {
    return array.map(item => ({
        emailDetailId: item.value.emailDetailId || null,
        isMomSender: item.value.isMomSender || "N",
        isAttendee: nonAttendees.some(row => row?.participantEmail === item.value.participantEmail) ? 'Y' : 'N',
        participantEmail: item.value.participantEmail || "",
        emailTypeMaster: {
            emailTypeId: emailType === "From" ? 1 : (emailType === "To" ? 2 : 3),
            emailType: emailType
        }
    }));
};
export { convertToConsolidatedFormat };

const validateFormInputs = (emailfrom, emailto, meetingSummary, attendeesData, setFormErrors, handleChange, tablerow,momData) => {
    let formErrors = [];
    const emailfromError = validateInput("emailfrom", emailfrom, setFormErrors, handleChange, tablerow);
    const emailtoError = validateInput("emailto", emailto, setFormErrors, handleChange, tablerow);
    const meetingSummaryError = validateInput("meetingSummary", meetingSummary, setFormErrors, handleChange, tablerow);
    const attendeesError = validateInput("attendees", attendeesData?.filter((item) => item.isAttendee === "Y"), setFormErrors, handleChange, tablerow);
    const actionItemsError =validateInput("actionItems", momData?.actionItems, setFormErrors, handleChange, tablerow)

    formErrors.push(emailfromError, emailtoError, attendeesError, meetingSummaryError,actionItemsError);
    return formErrors;
};
export { validateFormInputs };

const processActionItems = (actionItems) => {
    return actionItems?.map((i) => {
        let mon = i?.etaDate[1] < 10 ? `0${i?.etaDate[1]}` : `${i?.etaDate[1]}`;
        let day = i?.etaDate[2] < 10 ? `0${i?.etaDate[2]}` : `${i?.etaDate[2]}`;

        let mon1, day1;
        if (i?.closingDate) {
            mon1 = i?.closingDate[1] < 10 ? `0${i?.closingDate[1]}` : `${i?.closingDate[1]}`;
            day1 = i?.closingDate[2] < 10 ? `0${i?.closingDate[2]}` : `${i?.closingDate[2]}`;
        }

        return {
            ...i,
            etaDate: i?.etaDate ? (Array.isArray(i?.etaDate) ? `${i?.etaDate[0]}-${mon}-${day}` : moment(i?.etaDate).format("YYYY-MM-DD")) : "",
            closingDate: i?.closingDate ? (Array.isArray(i?.closingDate) ? `${i?.closingDate[0]}-${mon1}-${day1}` : moment(i?.closingDate).format("YYYY-MM-DD")) : ""
        };
    });
};
export { processActionItems };

const createBodyToSend = (mid, meetingSummary, actionItems, attachmentDocuments, act, startDate, endDate, startTime, endTime, duration, emailDetail) => {

    console.log("createBodyToSend actionItems",actionItems)

    return {
        "mid": mid,
        "meetingSummary": meetingSummary,
        "actionItems": actionItems,
        "attachmentDocuments": attachmentDocuments,
        "action": act,
        "startDate": moment(startDate).format("YYYY-MM-DD"),
        "endDate": moment(endDate).format("YYYY-MM-DD"),
        "startTime": startTime,
        "endTime": endTime,
        "duration": duration,
        "emailDetail": emailDetail
    };
};
export { createBodyToSend };

const submitData = async (bodyToSend, token, setLoading, setSuccessMessage, setOpenSuccessModal, setFailMessage, setOpenFailModal, setSessionExpiredModal, act) => {
console.log("bodyToSend in submitData", bodyToSend)

    try {
        setLoading(true);
        const editMomResponse = await POST(Url.editMomMeeting, token, bodyToSend);
        if (editMomResponse.SUCCESS) {
            setLoading(false);
            let msg = (act === "save") ? "Minutes saved successfully" : "Minutes sent successfully";
            setSuccessMessage(msg);
            setOpenSuccessModal(true);
        } else if (editMomResponse.STATUS === 401) {
            setLoading(false);
            setSessionExpiredModal(true);
            setFailMessage("Session expired");
        } else if (editMomResponse.STATUS === 400) {
            setLoading(false);
            setSessionExpiredModal(true);
            setFailMessage("Session expired");
        } else if (editMomResponse.STATUS === 403) {
            setLoading(false);
            setSessionExpiredModal(true);
            setFailMessage("Session expired");
        } else if (editMomResponse.STATUS === 404) {
            setLoading(false);
            setSessionExpiredModal(true);
            setFailMessage("Session expired");
        } else if (editMomResponse.STATUS === 500) {
            setLoading(false);
            setSessionExpiredModal(true);
            setFailMessage("Session expired");
        } else {
            setLoading(false);
            setFailMessage("Failed to edit minutes.");
            setOpenFailModal(true);
        }
    } catch (error) {
        setLoading(false);
        setFailMessage("Failed to edit minutes.");
        setOpenFailModal(true);
    }
};
export { submitData };

export const handleTaskNameChange = ({
    event,
    setTaskNameError,
    handleAddRow,
    tablerow,
    setTablerow,
    adjustTextareaHeightofNewItem,
}) => {
    const value = event.target.value;
    const hasLeadingWhitespace = !/^[^\s]/.test(value);
    const isEmpty = value.trim() === "";

    if (hasLeadingWhitespace || isEmpty) {
        setTaskNameError({
            errormsg: "Input cannot have leading whitespace or be empty.",
            errorstatus: true,
        });
    } else {
        setTaskNameError({
            errormsg: "",
            errorstatus: false,
        });
    }

    handleAddRow("taskName", event, tablerow, setTablerow);
    adjustTextareaHeightofNewItem(); // Adjust height on each change
};

const EditPastMeeting = () => {

    const location = useLocation();
    const { setLoading, setActive } = useContext(contextData);
    const navigate = useNavigate();
    const token = sessionStorage.getItem("TOKEN");

    let Email = Cuurent_EMAIL();
    // modal states--------------------------------------------
    const [openSuccessModal, setOpenSuccessModal] = useState(false);
    const [successMessage, setSuccessMessage] = useState("");
    const [openFailModal, setOpenFailModal] = useState(false);
    const [failMessage, setFailMessage] = useState("");
    const [sessionExpiredModal, setSessionExpiredModal] = useState(false)
    const [TaskNameError, setTaskNameError] = useState({
        "errormsg": "",
        "errorstatus": false
    });
    // ------------------------------------------------------------------------------Data States---------------------------------------------------------------

    const [employeeData, setEmployeeData] = useState([])
    const [filteredToEmployeeData, setFilteredToEmployeeData] = useState([]);
    const [filteredOptionalEmployeeData, setFilteredOptionalEmployeeData] = useState([]);
    const [actualData, setActualData] = useState([])
    const [inputVal, setInputVal] = useState("");
    const [optionalInputVal, setOptionalInputVal] = useState("")
    const [fromObject, setFromObject] = useState({});
    const [act, setAct] = useState("save");
    const [attendeesData, setAttendeesData] = useState([])

    const [addNewActionItemClicked, setAddNewActionItemClicked] = useState(false)

    // ------------------------------------------------------------------------------Boolean States------------------------------------------------------------
    const [openToUserList, setOpenToUserList] = useState(false);
    const [openOptionalUserList, setOpenOptionalUserList] = useState(false);
    const [selectAllAttendee, setSelectAllAttendee] = useState(false);
    const [preventFirst, setPreventFirst] = useState(false);
    // Get today's date
    const today = new Date();
    const [options, setOptions] = useState([])
    const [momData, setMomData] = useState({

        "mid": "",
        "emailDetailId": "",
        "emailfrom": "",
        "momSenderEmail": "",
        "emailto": [],
        "emailoptional": [],
        "attendees": [],
        "actionItems": [],
        "attachmentDocuments": [],
        "meetingAgenda": "",
        "meetingSummary": "",
        "meetingSubject": "",
        "startDate": "",
        "endDate": "",
        "meetingLocation": "",
        "startTime": "",
        "endTime": "",
        "duration": "",
        "recordedBy": "",
        "isAllDay": false,
        "momVersion": "",
        "editViewMomVersion": '',
        "emailDetail": []
    })

    console.log('momData, options, attendeesData==>>', momData, options, attendeesData)
    const [tempCheckedValues, setTempCheckedValues] = useState([]);
    const [menuVisible, setMenuVisible] = useState(false);
    const menuRef = useRef(null);





    const toggleMenu = () => {
        setMenuVisible(!menuVisible);
    };

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (menuRef.current && !menuRef.current.contains(event.target)) {
                setMenuVisible(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    const customStylesMulti = {
        control: (provided) => ({
            ...provided,
            border: '1px solid #ced4da',
            borderRadius: '5px',
            boxShadow: 'none',
            minHeight: '34px',
        }),
        option: (provided, state) => ({
            ...provided,
            backgroundColor: state.isSelected ? '#007bff' : state.isFocused ? '#f8f9fa' : 'white',
            color: state.isSelected ? 'white' : state.isFocused ? '#007bff' : 'black',
            fontSize: "14px",
            margin: "0px",
            borderBottom: "1px solid #ccc",
            height: "30px",
            cursor: 'pointer',
            transition: 'background-color 0.2s, color 0.2s',
            '&:hover': {
                backgroundColor: state.isSelected ? '#0056b3' : '#f8f9fa',
                color: state.isSelected ? 'white' : '#007bff',
            },
        }),
        menu: (provided) => ({
            ...provided,
            maxHeight: '122px',
        }),
        menuList: (provided) => ({
            ...provided,
            maxHeight: '120px',
            overflowY: 'auto',
        }),
        dropdownIndicator: () => ({
            display: 'none' // Hide the dropdown arrow
        }),
        indicatorSeparator: () => ({
            display: 'none' // Hide the indicator separator
        }),
        clearIndicator: (provided) => ({
            ...provided,
            padding: '6px', // Adjust padding to reduce the size of the clear indicator
        }),
        indicatorsContainer: (provided) => ({
            ...provided,
            height: '30px'
        }),
        valueContainer: (provided) => ({
            ...provided,
            padding: "4px"
        }),
        input: (provided, state) => ({
            ...provided,
            minHeight: '20px', // Adjust the input height as needed
        }),
        placeholder: (provided, state) => ({
            ...provided,
            marginTop: '4px',
            fontSize: '13px'
        }),
    };

    const module = {
        toolbar: [
            ['bold', 'italic', 'underline', 'strike'],
            [{ 'list': 'ordered' }, { 'list': 'bullet' }],
            ['clean']
        ]
    };

    useEffect(() => {

    }, [momData])
    const [tablerow, setTablerow] = useState({
        "actionItemId": null,
        "taskName": "",
        "ownerName": "",
        "etaDate": "",
        "closingDate": "",
        "assignedTo": null,
        "assignedToList": []
    })

    useEffect(() => {


    }, [tablerow])

    const [formErrors, setFormErrors] = useState({
        "emailfrom": "",
        "emailto": "",
        "attendees": "",
        "actionItems": "",
        "meetingSummary": "",
    })

   




    const toRef = useRef();
    const optRef = useRef();

    useEffect(() => {

    }, [formErrors])
    // -------------------------------------------------------------------------------- GET APIS ----------------------------------------------------------------------------------------

    const [TimeArray, setTimeArray] = useState([
        "12:00 AM",
        "12:30 AM",
        "01:00 AM",
        "01:30 AM",
        "02:00 AM",
        "02:30 AM",
        "03:00 AM",
        "03:30 AM",
        "04:00 AM",
        "04:30 AM",
        "05:00 AM",
        "05:30 AM",
        "06:00 AM",
        "06:30 AM",
        "07:00 AM",
        "07:30 AM",
        "08:00 AM",
        "08:30 AM",
        "09:00 AM",
        "09:30 AM",
        "10:00 AM",
        "10:30 AM",
        "11:00 AM",
        "11:30 AM",
        "12:00 PM",
        "12:30 PM",
        "01:00 PM",
        "01:30 PM",
        "02:00 PM",
        "02:30 PM",
        "03:00 PM",
        "03:30 PM",
        "04:00 PM",
        "04:30 PM",
        "05:00 PM",
        "05:30 PM",
        "06:00 PM",
        "06:30 PM",
        "07:00 PM",
        "07:30 PM",
        "08:00 PM",
        "08:30 PM",
        "09:00 PM",
        "09:30 PM",
        "10:00 PM",
        "10:30 PM",
        "11:00 PM",
        "11:30 PM",
    ]);

    const optionsStart = TimeArray.map((item, index) => ({
        label: item,
        value: item,
        isDisabled: false
    }));


    function isStartTimeGreaterThanEndTime(startTime, endTime) {
        const startDateTime = moment(startTime, 'hh:mm A');
        const endDateTime = moment(endTime, 'hh:mm A');

        let result = startDateTime.isSameOrAfter(endDateTime);
        return result;
    }

    const optionsEnd = TimeArray.map((item, index) => ({
        label: item,
        value: item,
        isDisabled: isStartTimeGreaterThanEndTime(momData?.startTime, item)
    }));






    const [startTimeArr, setStartTimeArr] = useState([...optionsStart])
    const [org, setOrg] = useState(false);


    useEffect(() => {
        let roles = Cuurent_USER_ROLES();

        let isOrganizer = roles?.includes("QMS Organizer");
        setOrg(isOrganizer)

    }, [])


   

    useEffect(() => {
        adjustTextareaHeightofNewItem()
    }, [tablerow])

    // -------------------------------------------------------------------------------- DropDown APIS ----------------------------------------------------------------------------------------


    useEffect(() => {
        const dependencies = {
            setLoading, setSessionExpiredModal, setFailMessage, setOpenFailModal, setMomData,
            setFilteredToEmployeeData, setFilteredOptionalEmployeeData, GET, Url, token, Email, getEmailClassification, location
        };

        Promise.all([getMeetingData({
            setLoading,
            location,
            setFromObject,
            setAttendeesData,
            attendeesData,
            setOptions,
            setActualData,
            setMomData,
            setSessionExpiredModal,
            setFailMessage,
            setOpenFailModal
        })])
            .then(([meetingDataResult]) => fetchAllDropDownData(meetingDataResult, dependencies))
            .then(() => setLoading(false))
            .catch(() => setLoading(false));
    }, []);



    const handleChange = (fieldName, e) => {
        let name, value;
        if (e?.target) {
            name = e.target.name;
            value = e.target.value;
        } else {
            name = fieldName;
            value = e;
        }

        switch (name) {
            case "emailto":
                handleEmailToChange(value,
                     momData,
                     setMomData,
                      filteredOptionalEmployeeData,
                    setFilteredToEmployeeData);
                break;
            case "emailoptional":
                handleEmailOptionalChange(value,
                     momData,
                     setMomData, 
                     filteredOptionalEmployeeData,
                     setFilteredToEmployeeData);
                break;
            case "EmailToRemove":
                handleEmailToRemove(value, momData, setMomData);
                break;
            case "EmailOptionalRemove":
                handleEmailOptionalRemove(value, momData, setMomData);
                break;
            case "attachmentDocuments":
                handleAttachmentDocumentsChange(value, momData, setMomData);
                break;
            case "actionItems":
                handleActionItemsChange(value, setTablerow, setAddNewActionItemClicked, momData, setMomData);
                break;
            case "startTime":
                handleStartTimeChange(value, momData, setMomData, TimeArray, timeDifference);
                break;
            case "endTime":
                handleEndTimeChange(value, momData, timeDifference, setMomData);
                break;
            default:
                handleDefaultChange(name, value, setMomData);
                break;
        }

        // Validation handling
        if (name === "emailTo") {
            validateInput("emailTo", momData?.emailto, setFormErrors, handleChange, tablerow);
        } else if (name === "meetingSummary") {
            validateInput(name, stripHtmlTags(value), setFormErrors, handleChange, tablerow);
        } else if (name !== "actionItems") {
            validateInput(name, value, setFormErrors, handleChange, tablerow);
        }
    };


    useEffect(() => {
        // Call the adjustment function on initial render and whenever `tablerow?.taskName` changes
        adjustTextareaHeightofNewItem();
    }, [tablerow?.taskName]);

    const adjustTextareaHeightofNewItem = () => {
        const element = document?.getElementById('new-item');
        if (element) {
            element.style.height = 'auto';
            element.style.height = element.scrollHeight + 'px';
        }
    };


    // function to handleNavigate after submit
    const navigateAfterSubmit = () => {
        org ? navigate("/main/meetings/meeting-summary") : navigate("/main/meetings/my-meetings");
        setMomData({
            "mid": "",
            "emailDetailId": "",
            "emailfrom": "",
            "emailto": [],
            "emailoptional": [],
            "attendees": [],
            "actionItems": [],
            "attachmentDocuments": [],
            "meetingAgenda": "",
            // "meetingSummary": "",
            "meetingSubject": "",
            "startDate": "",
            "endDate": "",
            "meetingLocation": "",
            "startTime": "",
            "endTime": "",
            "duration": "",
            "recordedBy": ""
        })
    }
    // -------------------------------------------------------------------------------- handle Edit Submit APIS ----------------------------------------------------------------------------------------
    const handleEditFormData = async (e) => {
        e.preventDefault();
        const { mid, emailDetailId, emailfrom, emailto, emailoptional, attendees, attachmentDocuments, actionItems, meetingSummary, startDate, endDate, startTime, endTime, duration, emailDetail } = momData;
        const editedMeetingSummary = stripHtmlTags(meetingSummary);
        let isValidForm = true;

        const nonAttendees = attendeesData.filter(item => item?.isAttendee === 'Y');

        const editedEmailDetails = [
            ...convertToConsolidatedFormat(emailfrom, "From", nonAttendees),
            ...convertToConsolidatedFormat(emailto, "To", nonAttendees),
            ...convertToConsolidatedFormat(emailoptional, "Optional", nonAttendees)
        ];

        const seenEmails = new Set();
        const uniqueEmailDetails = editedEmailDetails.filter(item => {
            if (seenEmails.has(item.participantEmail)) {
                return false;
            }
            seenEmails.add(item.participantEmail);
            return true;
        });

        const formErrors = validateFormInputs(emailfrom, emailto, editedMeetingSummary, attendeesData, setFormErrors, handleChange, tablerow, momData);
        formErrors.forEach((err) => {
            if (err !== "") {
                isValidForm = false;
            }
        });

        if (isValidForm) {
            const getSegregatedEmails = getEmailClassification(fromObject);
            const actionItemsProcessed = processActionItems(actionItems);
            const emailDetails = createBodyToSend(mid, editedMeetingSummary, actionItemsProcessed, attachmentDocuments, act, startDate, endDate, startTime, endTime, duration, uniqueEmailDetails);

            console.log(" submitData emailDetails", emailDetails)

            

            await submitData(emailDetails, token, setLoading, setSuccessMessage, setOpenSuccessModal, setFailMessage, setOpenFailModal, setSessionExpiredModal, act);
        }
    };

    const handleCloseFailModel = () => {
        setOpenFailModal(false);
    }

    




    return (
        <div className="edit-past-main-container" id='capture'>
            <div className="edit-past-header">
                <h4>Minutes Of Meeting</h4>
            </div>
            <form className="edit-past-form-container" data-testid="handleEditFormData1" onSubmit={handleEditFormData}>
                <div className="from-to-field">
                    <div className="first-label-container first-label-title">
                        <label htmlFor=""><span>From:</span> </label>
                        <label htmlFor=""><span>Meeting Subject:</span>  </label>
                    </div>
                    <div className="first-field-container first-label-data-cont">
                        <div className="inputs first-label-title">
                            <div className="" style={{ width: "100%" }}>
                                <input
                                    style={{ paddingLeft: '5px' }}
                                    className='border'
                                    type="text"
                                    data-testid="emailfrom"
                                    name="emailfrom"
                                    value={momData?.emailfrom[0]?.label || ''}
                                    onChange={(e) => handleChange("emailfrom", e)}
                                    disabled={true}
                                />
                                {
                                    formErrors?.emailfrom && <div className='form-error field-containerr'>{formErrors?.emailfrom}</div>
                                }
                            </div>
                          

                            <div style={{ width: '100%' }} className="field field-value"><span>{momData?.meetingSubject}</span> </div>
                        </div>
                        <div className="send-btn">
                            <button data-testid="setActsend" onClick={() => {
                                // handleSubmitDummy()
                                setAct("send")

                            }}>
                                <span>Send</span>
                                <svg xmlns="http://www.w3.org/2000/svg" width="42.015px" height="42.015px" viewBox="0 0 73.015 72.429" >
                                    <g id="Icon_feather-send" data-name="Icon feather-send" transform="translate(36.214 -2.828) rotate(45)" >
                                        <path id="Path_152274" data-name="Path 152274" d="M43.568,3,16.5,30.068" transform="translate(8.647 0)" fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" />
                                        <path id="Path_152275" data-name="Path 152275" d="M52.215,3,34.99,52.215,25.147,30.068,3,20.225Z" transform="translate(0 0)" fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" />
                                    </g>
                                </svg>
                            </button>
                        </div>
                    </div>
                </div>
                <div className="field-container"
                // onClick={() => { handleDivClick("to") }}
                >
                    <div className="label">
                        <label htmlFor="">To<span style={{ color: "red" }}>*</span>:</label>
                    </div>
                    <div className="field to-relative">
                        <Select
                            className="multiselect_email_past"
                            isMulti={true}
                            value={momData?.emailto}
                            styles={customStylesMulti}
                            onChange={(item) => handleChange("emailto", item)}
                            options={filteredToEmployeeData}
                            inputValue={inputVal}
                            onInputChange={(val) => { setInputVal(val) }}
                            menuIsOpen={inputVal?.length >= 3 ? true : false}
                        />
                        {formErrors?.emailto && (
                            <div
                                className="form-error field-containerr"
                            >
                                {formErrors?.emailto}
                            </div>
                        )}
                        {(inputVal?.length < 3 && inputVal != "") &&
                            <div className="user-list" style={{ fontSize: 13 }}> Please enter at least 3 characters.</div>
                        }
                    </div>
                    {/* ----------------------------------------------------------------------------------------------------------------------------------- */}
                </div>
                <div className="field-container"
                // onClick={() => { handleDivClick("optional"); }}
                >
                    <div className="label">
                        <label htmlFor="">Optional:</label>
                    </div>
                    <div className="field to-relative">
                        <Select
                            isMulti={true}
                            className="multiselect_email_past"
                            value={momData?.emailoptional}
                            styles={customStylesMulti}
                            onChange={(item) => handleChange("emailoptional", item)}
                            options={filteredToEmployeeData}
                            inputValue={optionalInputVal}
                            onInputChange={(val) => { setOptionalInputVal(val) }}
                            menuIsOpen={optionalInputVal?.length >= 3 ? true : false}
                        />
                        {(optionalInputVal?.length < 3 && optionalInputVal != "") &&
                            <div className="user-list" style={{ fontSize: 13 }}> Please enter at least 3 characters.</div>
                        }
                    </div>
                </div>
                <div className="field-container">
                    <div className="label">
                        <label htmlFor="">Start<span style={{ color: "red" }}>*</span>:</label>
                    </div>
                    <div className="field date-field" >
                        <div className="date-inner" style={{ width: '52%', }}>
                            <div className="field-value recordedBy-EPM" style={{ width: '84%', display: "flex", alignItems: " center", justifyContent: 'space-between', backgroundColor: 'white', gap: '6px', border: "1px solid #B8B8B8", borderRadius: '5px' }}>
                                <span style={{ paddingLeft: '0%', paddingTop: " 3px" }}>   <svg
                                    id="calendar-line-icon"
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="19.119px"
                                    height="27.122"
                                    viewBox="0 0 27.119 27.122"
                                >
                                    <path
                                        id="Path_15922"
                                        data-name="Path 15922"
                                        d="M18.011,1.044A1.176,1.176,0,0,1,19.285,0a1.176,1.176,0,0,1,1.273,1.044V5.617a1.176,1.176,0,0,1-1.273,1.044,1.176,1.176,0,0,1-1.273-1.044V1.044ZM14.59,22.911c-.075,0-.135-.316-.135-.706s.06-.706.135-.706h3.485c.075,0,.135.316.135.706s-.06.706-.135.706ZM3.5,14.807c-.075,0-.135-.316-.135-.706s.06-.706.135-.706H6.983c.075,0,.135.316.135.706s-.06.706-.135.706Zm5.546,0c-.075,0-.135-.316-.135-.706s.06-.706.135-.706h3.485c.075,0,.135.316.135.706s-.06.706-.135.706Zm5.546,0c-.075,0-.135-.316-.135-.706s.06-.706.135-.706h3.485c.075,0,.135.316.135.706s-.06.706-.135.706Zm5.548,0c-.075,0-.135-.316-.135-.706s.06-.706.135-.706h3.485c.075,0,.135.316.135.706s-.06.706-.135.706ZM3.5,18.859c-.075,0-.135-.316-.135-.706s.06-.706.135-.706H6.983c.075,0,.135.316.135.706s-.06.706-.135.706Zm5.546,0c-.075,0-.135-.316-.135-.706s.06-.706.135-.706h3.485c.075,0,.135.316.135.706s-.06.706-.135.706Zm5.546,0c-.075,0-.135-.316-.135-.706s.06-.706.135-.706h3.485c.075,0,.135.316.135.706s-.06.706-.135.706Zm5.548,0c-.075,0-.135-.316-.135-.706s.06-.706.135-.706h3.485c.075,0,.135.316.135.706s-.06.706-.135.706ZM3.5,22.911c-.075,0-.135-.316-.135-.706s.06-.706.135-.706H6.983c.075,0,.135.316.135.706s-.06.706-.135.706Zm5.546,0c-.075,0-.135-.316-.135-.706s.06-.706.135-.706h3.485c.075,0,.135.316.135.706s-.06.706-.135.706ZM6.535,1.044A1.176,1.176,0,0,1,7.808,0,1.176,1.176,0,0,1,9.082,1.044V5.617A1.176,1.176,0,0,1,7.808,6.661,1.176,1.176,0,0,1,6.535,5.617V1.044ZM1.412,10H25.7V4.738a.652.652,0,0,0-.19-.457.644.644,0,0,0-.457-.19H22.732a.706.706,0,0,1,0-1.412H25.06a2.065,2.065,0,0,1,2.059,2.059V25.062a2.065,2.065,0,0,1-2.059,2.059h-23A2.065,2.065,0,0,1,0,25.06V4.738A2.065,2.065,0,0,1,2.059,2.679H4.546a.706.706,0,1,1,0,1.412H2.059a.652.652,0,0,0-.457.19.644.644,0,0,0-.19.457V10Zm24.294,1.415H1.412V25.06a.652.652,0,0,0,.19.457.644.644,0,0,0,.457.19h23a.652.652,0,0,0,.457-.19.644.644,0,0,0,.19-.457V11.417ZM11.13,4.092a.706.706,0,0,1,0-1.412h4.743a.706.706,0,0,1,0,1.412Z"
                                        fill="#00aff1"
                                    />
                                </svg></span>
                                <DatePicker
                                    value={momData?.startDate}
                                    selected={momData?.startDate}
                                    onChange={(date) => handleChange("startDate", date)}
                                    dateFormat="dd/MM/yyyy"
                                /> </div>
                        </div>


                        <div className="label">
                            <label htmlFor="" style={{ fontSize: "14px", display: "flex", alignItems: 'center', justifyContent: 'center', width: '13%' }} >End<span style={{ color: "red" }}>*</span>:</label>
                        </div>
                        <div className="date-inner" style={{ width: '47%', }}>
                            <div className="field-value recordedBy-EPM" style={{ width: '93%', display: "flex", alignItems: " center", justifyContent: 'space-between', backgroundColor: 'white', gap: '6px', border: "1px solid #B8B8B8", borderRadius: '5px' }}>
                                <span style={{ paddingLeft: '0%', paddingTop: " 3px" }}>   <svg
                                    id="calendar-line-icon"
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="19.119px"
                                    height="27.122"
                                    viewBox="0 0 27.119 27.122"

                                >
                                    <path
                                        id="Path_15922"
                                        data-name="Path 15922"
                                        d="M18.011,1.044A1.176,1.176,0,0,1,19.285,0a1.176,1.176,0,0,1,1.273,1.044V5.617a1.176,1.176,0,0,1-1.273,1.044,1.176,1.176,0,0,1-1.273-1.044V1.044ZM14.59,22.911c-.075,0-.135-.316-.135-.706s.06-.706.135-.706h3.485c.075,0,.135.316.135.706s-.06.706-.135.706ZM3.5,14.807c-.075,0-.135-.316-.135-.706s.06-.706.135-.706H6.983c.075,0,.135.316.135.706s-.06.706-.135.706Zm5.546,0c-.075,0-.135-.316-.135-.706s.06-.706.135-.706h3.485c.075,0,.135.316.135.706s-.06.706-.135.706Zm5.546,0c-.075,0-.135-.316-.135-.706s.06-.706.135-.706h3.485c.075,0,.135.316.135.706s-.06.706-.135.706Zm5.548,0c-.075,0-.135-.316-.135-.706s.06-.706.135-.706h3.485c.075,0,.135.316.135.706s-.06.706-.135.706ZM3.5,18.859c-.075,0-.135-.316-.135-.706s.06-.706.135-.706H6.983c.075,0,.135.316.135.706s-.06.706-.135.706Zm5.546,0c-.075,0-.135-.316-.135-.706s.06-.706.135-.706h3.485c.075,0,.135.316.135.706s-.06.706-.135.706Zm5.546,0c-.075,0-.135-.316-.135-.706s.06-.706.135-.706h3.485c.075,0,.135.316.135.706s-.06.706-.135.706Zm5.548,0c-.075,0-.135-.316-.135-.706s.06-.706.135-.706h3.485c.075,0,.135.316.135.706s-.06.706-.135.706ZM3.5,22.911c-.075,0-.135-.316-.135-.706s.06-.706.135-.706H6.983c.075,0,.135.316.135.706s-.06.706-.135.706Zm5.546,0c-.075,0-.135-.316-.135-.706s.06-.706.135-.706h3.485c.075,0,.135.316.135.706s-.06.706-.135.706ZM6.535,1.044A1.176,1.176,0,0,1,7.808,0,1.176,1.176,0,0,1,9.082,1.044V5.617A1.176,1.176,0,0,1,7.808,6.661,1.176,1.176,0,0,1,6.535,5.617V1.044ZM1.412,10H25.7V4.738a.652.652,0,0,0-.19-.457.644.644,0,0,0-.457-.19H22.732a.706.706,0,0,1,0-1.412H25.06a2.065,2.065,0,0,1,2.059,2.059V25.062a2.065,2.065,0,0,1-2.059,2.059h-23A2.065,2.065,0,0,1,0,25.06V4.738A2.065,2.065,0,0,1,2.059,2.679H4.546a.706.706,0,1,1,0,1.412H2.059a.652.652,0,0,0-.457.19.644.644,0,0,0-.19.457V10Zm24.294,1.415H1.412V25.06a.652.652,0,0,0,.19.457.644.644,0,0,0,.457.19h23a.652.652,0,0,0,.457-.19.644.644,0,0,0,.19-.457V11.417ZM11.13,4.092a.706.706,0,0,1,0-1.412h4.743a.706.706,0,0,1,0,1.412Z"
                                        fill="#00aff1"
                                    />
                                </svg></span>
                                <DatePicker
                                    value={momData?.endDate}
                                    selected={momData?.endDate}
                                    onChange={(date) => handleChange("endDate", date)}
                                    dateFormat="dd/MM/yyyy"
                                /> </div>
                        </div>
                        <div className="date-inner" style={{ width: '81%' }}>
                            <label style={{ fontSize: "14px", display: "flex", alignItems: 'center', justifyContent: 'center', width: '33%' }} htmlFor="">Starts :</label>
                            <div style={{ display: 'flex', border: "1px solid #B8B8B8", borderRadius: '5px', width: '72%', backgroundColor: momData.isAllDay && "#F3F3F3" }}>
                                <span style={{ marginTop: "5px ", paddingLeft: '2%' }}>
                                    <MdOutlineWatchLater color='#00AFF1' fontSize={"24px"} />
                                </span>
                                <div className='field-value' style={{ backgroundColor: momData.isAllDay ? "#F3F3F3" : "white" }}>

                                    <CreatableSelect
                                        options={startTimeArr}
                                        isSearchable={true}
                                        placeholder="Start time"
                                        isDisabled={momData?.isAllDay}
                                        name="startTime"
                                        value={{ label: momData?.startTime, value: momData?.startTime, isDisabled: false }}
                                        onChange={(time) => {
                                            handleChange('startTime', time)
                                        }}
                                        onCreateOption={(val) => handleCreateOption(val, "startTime", 
                                            momData,
                                            setMomData,
                                            setFailMessage,
                                            setOpenFailModal
                                        )}
                                        styles={{
                                            control: (provided, state) => ({
                                                ...provided,
                                                border: 'none',
                                                minHeight: "32px",
                                                borderRadius: '5px',
                                                height: '15px',
                                                fontSize: '13px',
                                                marginLeft: "-6px",
                                                color: "black",
                                                width: '115px',
                                                boxShadow: state.isFocused ? 'none' : state.isHovered ? '0 0 0 2px #00aff1' : 'none',
                                                '&:hover': {
                                                    borderColor: state.isFocused ? '#00aff1' : '#ccc'
                                                }
                                            }),
                                            option: (provided, state) => ({
                                                ...provided,
                                                // backgroundColor: state.isSelected ? '#00aff1' : 'white',
                                                color: state.isSelected ? 'white' : 'black',
                                                fontSize: '12px',
                                                '&:hover': {
                                                    backgroundColor: '#00000029',
                                                    color: 'white'
                                                }
                                            }),
                                            menu: (provided) => ({
                                                ...provided,
                                                width: '150px',
                                                maxHeight: '200px',
                                                zIndex: 9999
                                            }),
                                            menuList: (provided) => ({
                                                ...provided,
                                                maxHeight: '125px',
                                                overflowY: 'auto'
                                            })
                                        }}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="date-inner" style={{ width: '81%', }}>
                            <label style={{ fontSize: "14px", display: "flex", alignItems: 'center', justifyContent: 'center', width: '33%' }} htmlFor="">End :</label>
                            <div style={{ display: 'flex', border: "1px solid #B8B8B8", borderRadius: '5px', width: '72%', backgroundColor: momData?.isAllDay && "#F3F3F3" }}>
                                <span style={{ marginTop: "5px ", paddingLeft: '2%' }}>
                                    <MdOutlineWatchLater color='#00AFF1' fontSize={"24px"} />
                                </span>
                                <div className='field-value' style={{ backgroundColor: momData?.isAllDay ? "#F3F3F3" : "white" }}>

                                    <CreatableSelect
                                        options={optionsEnd}
                                        isSearchable={true}
                                        isDisabled={momData?.isAllDay}
                                        placeholder="End time"
                                        name="endTime"
                                        value={{ label: momData?.endTime, value: momData?.endTime, isDisabled: false }}
                                        onChange={(time) => { handleChange('endTime', time); }}
                                        onCreateOption={(val) => handleCreateOption(val, "endTime", 
                                            momData,
                                            setMomData,
                                            setFailMessage,
                                            setOpenFailModal
                                        )}
                                        styles={{
                                            control: (provided, state) => ({
                                                ...provided,
                                                border: 'none',
                                                minHeight: "32px",
                                                borderRadius: '5px',
                                                height: '15px',
                                                fontSize: '13px',
                                                marginLeft: "-6px",
                                                color: "black",
                                                width: '115px',
                                                boxShadow: state.isFocused ? 'none' : state.isHovered ? '0 0 0 2px #00aff1' : 'none',
                                                '&:hover': {
                                                    borderColor: state.isFocused ? '#00aff1' : '#ccc'
                                                }
                                            }),
                                            option: (provided, state) => ({
                                                ...provided,
                                                // backgroundColor: state.isSelected ? '#00aff1' : 'white',
                                                color: state.isSelected ? 'white' : 'black',
                                                fontSize: '12px',
                                                '&:hover': {
                                                    backgroundColor: '#00000029',
                                                    color: 'white'
                                                }
                                            }),
                                            menu: (provided) => ({
                                                ...provided,
                                                width: '150px',
                                                maxHeight: '200px',
                                                zIndex: 9999
                                            }),
                                            menuList: (provided) => ({
                                                ...provided,
                                                maxHeight: '125px',
                                                overflowY: 'auto'
                                            })
                                        }}
                                    />
                                </div>
                            </div>
                           
                        </div>
                        
                        <div style={{ width: '100%', display: 'flex', flexDirection: 'row', }}>
                            <div className='EPM-all date-inner' style={{ width: '30%', height: '100%', display: 'flex', justifyContent: 'space-between', gap:'4px', margin: " 8px 8px 0px 15px" }}>
                                <input
                                    checked={momData?.isAllDay}
                                    type="checkbox"
                                    name="isAllDay"
                                    style={{ width: "20px", }}
                                    onChange={(e) => {
                                        const ntime = nearestTime()
                                        if (!momData.isAllDay) {
                                            setMomData((PrevState) => ({ ...PrevState, startTime: "12:00 AM", endTime: "12:00 AM", duration: "24h : 00m" }))
                                        }
                                        else {
                                            setMomData((PrevState) => ({
                                                ...PrevState, startTime: ntime,
                                                endTime: TimeArray?.indexOf(ntime) + 1 == TimeArray?.length ? TimeArray[0] : TimeArray[TimeArray?.indexOf(ntime) + 1],
                                                duration: "00h : 30m"
                                            }))

                                        }
                                        handleChange("isAllDay", !momData?.isAllDay);

                                    }}

                                />
                                <label style={{ fontSize: "14px", display: "flex", alignItems: 'left', justifyContent: 'flex-start', width: "80%" }} htmlFor="">All Day</label>

                            </div>
                            <div className="" style={{ width: '70%', display: 'flex', flexDirection: 'row', gap: '15px' }}> <label style={{ fontSize: "14px", display: "flex", alignItems: 'center', justifyContent: 'center', width: '30%' }} htmlFor="">Duration:</label>
                                <div style={{ width: '70%' }} className="field-value"> <span>{momData?.duration}</span> </div>
                            </div>

                        </div>

                    </div>
                </div>
              
                <div className="field-container">
                    <div className="label">
                        <label htmlFor="">Agenda:</label>
                    </div>

                    <div className="field  agenda-field" style={{ backgroundColor: "#F3F3F3", padding: "5px", fontSize: 13, display: "flex", alignItems: "center", minHeight: 34 }}>
                        <div dangerouslySetInnerHTML={{ __html: momData?.meetingAgenda }}></div>
                    </div>
                </div>
                <div className="field-container">
                    <div className="label">
                        <label htmlFor="">Version:</label>
                    </div>
                    <div className="field recorded-field" >
                        <div className="date-inner" style={{ width: '50%' }}>
                            <div className="field-value recordedBy-EPM"> <span>{momData?.editViewMomVersion}</span> </div>
                        </div>
                        <div className="date-inner EPM-location-cont">
                            <label htmlFor="" style={{ fontSize: '14px' }}>Location:</label>
                            <div className="field-value recordedBy-EPM"> <span>{momData?.meetingLocation}</span> </div>
                        </div>
                    </div>
                </div>
                <div className="field-container">
                    <div className="label">
                        <label htmlFor="">Attendees<span style={{ color: "red" }}>*</span>:</label>
                    </div>
                    <div className="field">
                        <div className="attendees-field border" style={{ minHeight: '34px' }}>
                            <div className="select-fields">
                                {attendeesData.map((item, index) => (
                                    <span key={index} style={{ display: "flex", justifyContent: "center", alignItems: "center", gap: 4 }}>
                                        <input
                                            type="checkbox"
                                            checked={item.isAttendee === "Y"}
                                            onChange={() => handleSelectAttendee(index,
                                                attendeesData,
                                                setAttendeesData,
                                                validateInput,
                                                setPreventFirst, 
                                                setFormErrors, 
                                                handleChange, 
                                                tablerow

                                            )}
                                        />
                                        <span style={{ fontSize: "13px" }}>{item?.employeeMaster?.fullName}</span>
                                    </span>
                                ))}
                            </div>

                            {
                                attendeesData.length !== 0 &&
                                <div className="select-all" style={{ width: '10%', display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 5, fontSize: "14px" }}>
                                    <span>Select All</span>
                                    <input
                                        type="checkbox"
                                        checked={attendeesData.length > 0 && attendeesData.every(item => item.isAttendee === "Y")}
                                        onChange={() => handleSelectAllAttendees(attendeesData, setAttendeesData, validateInput, setPreventFirst, setFormErrors, handleChange, tablerow)}
                                    />
                                </div>
                            }


                        </div>
                        {
                            formErrors?.attendees && <div className='form-error field-containerr'>{formErrors?.attendees}</div>
                        }
                    </div>
                </div>

                <div className="field-container" style={{ height: "auto" }}>
                    <div className="label">
                        <label htmlFor="">Discussion <br /> Summary<span style={{ color: "red" }}>*</span>:</label>
                    </div>
                    <div className="field">
                        <div className="field  agenda-field" style={{ minHeight: '40px', width: "100%", padding: 0, fontSize: "14px", maxHeight: "auto", border: "none" }} >
                            <ReactQuill
                                style={{ width: "100%" }}
                                name="meetingSummary"
                                value={momData?.meetingSummary} onChange={(e) => {
                                    handleChange("meetingSummary", e);
                                }}
                                modules={module}
                            >
                            </ReactQuill>
                        </div>
                       
                        {
                            (formErrors?.meetingSummary) && <div className='form-error field-containerr'>{formErrors?.meetingSummary}</div>
                        }
                    </div>
                </div>
                <div className="field-container">
                    <div className="label">
                        <label htmlFor="">Attachments:</label>
                    </div>
                    <div className="field">
                        <FileUpload
                            handleFormChange={handleChange}
                            setFormData={setMomData}
                            formData={momData}
                            flow={"editPastMeeting"}
                            actualData={actualData}
                        />
                    </div>
                </div>
                <div className="field-container">
                    <div className="label">
                        <label htmlFor="">Action Items<span style={{ color: "red" }}>*</span>:</label>
                    </div>
                    <div className="field action-table" >
                        <table style={{ border: "1px solid #B8B8B8" }}>
                            <thead className='header' style={{ padding: '10px 0', borderBottom: "1px solid #B8B8B8" }}>
                                <tr style={{ fontSize: "15px" }}>
                                    <th className='th-srno table-headers'>Sr.No.</th>
                                    <th className='th-task table-headers'>Task</th>
                                    <th className='th-owner table-headers'>Owner</th>
                                    <th className='th-eta table-headers'>ETA</th>
                                    <th className='th-closing-date table-headers' >Closing Date</th>
                                    <th className='th-act table-headers'>Actions</th>

                                </tr>
                            </thead>
                            <tbody style={{}}>
                                {
                                    momData?.actionItems?.map((item, index) => {
                                        const tooltipText = Array.isArray(item.assignsedToList)
                                            ? item.assignedToList.map(assignedItem => assignedItem.fullName).join(', ')
                                            : item?.assignedTo?.fullName || '';

                                        const { etaDate, closingDate } = item;
                                        let etaDateConverted;
                                        let closingDateConverted;
                                        if (Array.isArray(etaDate)) {
                                            etaDateConverted = etaDate == null ? new Date : new Date(`${etaDate[0]}=${etaDate[1]}-${etaDate[2]}`);
                                        }
                                        else {
                                            etaDateConverted = etaDate;
                                        }
                                        if (Array.isArray(closingDate)) {
                                            closingDateConverted = closingDate == null ? new Date() : new Date(`${closingDate[0]}=${closingDate[1]}-${closingDate[2]}`);
                                        }
                                        else {
                                            closingDateConverted = closingDate;
                                        }
                                        return (
                                            <tr style={{ borderBottom: "1px solid #B8B8B8" }}>
                                                <td style={{ borderRight: "1px solid #B8B8B8" }}>
                                                    <div className="data" style={{ justifyContent: 'flex-end', textAlign: "right" }}>
                                                        {index + 1}
                                                    </div>
                                                </td>
                                                <td style={{ borderRight: "1px solid #B8B8B8" }}>
                                                    <div className="data" dangerouslySetInnerHTML={{ __html: transformText(item.taskName) }} />
                                                </td>

                                                <td style={{
                                                    borderRight: "1px solid #B8B8B8",
                                                    paddingInline: "10px",
                                                    whiteSpace: "nowrap",
                                                    overflow: "hidden",
                                                    textOverflow: "ellipsis",
                                                    maxWidth: "200px"
                                                }}
                                                    title={tooltipText}>
                                                    {Array.isArray(item.assignedToList) ? (
                                                        item.assignedToList.map((assignedItem, index) => (
                                                            <React.Fragment key={assignedItem.emailId}>
                                                                {index > 0 && <span>,&nbsp;</span>}
                                                                <span className='dataArray'>{assignedItem.fullName}</span>
                                                            </React.Fragment>
                                                        ))
                                                    ) : (
                                                        <div className="data">
                                                            {item?.assignedTo?.fullName}
                                                        </div>
                                                    )}

                                                </td>

                                                <td style={{ borderRight: "1px solid #B8B8B8" }}>
                                                    <div className="data date-data">
                                                      
                                                        <DatePicker
                                                            selected={etaDateConverted}
                                                            value={etaDateConverted}
                                                            dateFormat="dd/MM/yyyy"
                                                            popperPlacement="top-start"
                                                            disabled={true}
                                                        />
                                                    </div>
                                                </td>
                                               
                                                <td style={{ borderRight: "1px solid #B8B8B8" }}>
                                                    <div className='EPM-date-Pickerr-cont'>

                                                        <div className="data date-data" style={{ width: "85%", border: "1px solid #DDDDDD", borderRadius: 5, marginBottom: 5, marginTop: 5, boxShadow: "rgba(0, 0, 0, 0.16) 0px 1px 4px" }} >
                                                            <svg id="calendar-line-icon" xmlns="http://www.w3.org/2000/svg" width="19.119px" height="15.122px" viewBox="0 0 27.119 27.122"
                                                            >
                                                                <path id="Path_15922" data-name="Path 15922" d="M18.011,1.044A1.176,1.176,0,0,1,19.285,0a1.176,1.176,0,0,1,1.273,1.044V5.617a1.176,1.176,0,0,1-1.273,1.044,1.176,1.176,0,0,1-1.273-1.044V1.044ZM14.59,22.911c-.075,0-.135-.316-.135-.706s.06-.706.135-.706h3.485c.075,0,.135.316.135.706s-.06.706-.135.706ZM3.5,14.807c-.075,0-.135-.316-.135-.706s.06-.706.135-.706H6.983c.075,0,.135.316.135.706s-.06.706-.135.706Zm5.546,0c-.075,0-.135-.316-.135-.706s.06-.706.135-.706h3.485c.075,0,.135.316.135.706s-.06.706-.135.706Zm5.546,0c-.075,0-.135-.316-.135-.706s.06-.706.135-.706h3.485c.075,0,.135.316.135.706s-.06.706-.135.706Zm5.548,0c-.075,0-.135-.316-.135-.706s.06-.706.135-.706h3.485c.075,0,.135.316.135.706s-.06.706-.135.706ZM3.5,18.859c-.075,0-.135-.316-.135-.706s.06-.706.135-.706H6.983c.075,0,.135.316.135.706s-.06.706-.135.706Zm5.546,0c-.075,0-.135-.316-.135-.706s.06-.706.135-.706h3.485c.075,0,.135.316.135.706s-.06.706-.135.706Zm5.546,0c-.075,0-.135-.316-.135-.706s.06-.706.135-.706h3.485c.075,0,.135.316.135.706s-.06.706-.135.706Zm5.548,0c-.075,0-.135-.316-.135-.706s.06-.706.135-.706h3.485c.075,0,.135.316.135.706s-.06.706-.135.706ZM3.5,22.911c-.075,0-.135-.316-.135-.706s.06-.706.135-.706H6.983c.075,0,.135.316.135.706s-.06.706-.135.706Zm5.546,0c-.075,0-.135-.316-.135-.706s.06-.706.135-.706h3.485c.075,0,.135.316.135.706s-.06.706-.135.706ZM6.535,1.044A1.176,1.176,0,0,1,7.808,0,1.176,1.176,0,0,1,9.082,1.044V5.617A1.176,1.176,0,0,1,7.808,6.661,1.176,1.176,0,0,1,6.535,5.617V1.044ZM1.412,10H25.7V4.738a.652.652,0,0,0-.19-.457.644.644,0,0,0-.457-.19H22.732a.706.706,0,0,1,0-1.412H25.06a2.065,2.065,0,0,1,2.059,2.059V25.062a2.065,2.065,0,0,1-2.059,2.059h-23A2.065,2.065,0,0,1,0,25.06V4.738A2.065,2.065,0,0,1,2.059,2.679H4.546a.706.706,0,1,1,0,1.412H2.059a.652.652,0,0,0-.457.19.644.644,0,0,0-.19.457V10Zm24.294,1.415H1.412V25.06a.652.652,0,0,0,.19.457.644.644,0,0,0,.457.19h23a.652.652,0,0,0,.457-.19.644.644,0,0,0,.19-.457V11.417ZM11.13,4.092a.706.706,0,0,1,0-1.412h4.743a.706.706,0,0,1,0,1.412Z" fill="#00aff1"
                                                                />
                                                            </svg>
                                                            <DatePicker
                                                                selected={closingDateConverted}
                                                                value={closingDateConverted}
                                                                popperPlacement="top-start"
                                                                onChange={(date) => handleEditClosingDate("closingDate", date, index, momData, setMomData)}
                                                                dateFormat="dd/MM/yyyy"
                                                                // minDate={new Date(etaDateConverted)}
                                                                minDate={today} // Minimum date selectable is today
                                                                maxDate={today} // Maximum date selectable is today
                                                            />
                                                        </div>
                                                    </div>
                                                </td>
                                                <td style={{ borderRight: "1px solid #B8B8B8", }}>
                                                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', }}>
                                                        <AiOutlineDelete fill="#00CEFF" size={'20px'} style={{ cursor: 'pointer' }} onClick={() => handleDeleteRow(index, setMomData, momData)} />
                                                        {((momData?.actionItems.length - 1 == index && !addNewActionItemClicked)) && <AiOutlinePlus fill="#00CEFF" size={'22px'} style={{ cursor: 'pointer', marginLeft: 5 }}
                                                            onClick={() => { setAddNewActionItemClicked(true); }} />}
                                                    </div>
                                                </td>
                                            </tr>
                                        )
                                    })
                                }

                                {(momData?.actionItems.length == 0 || addNewActionItemClicked) && <tr>
                                    <td style={{ borderRight: "1px solid #B8B8B8", boxShadow: "rgba(0, 0, 0, 0.16) 0px 1px 4px" }}>
                                        <div className=" data date-data" style={{ justifyContent: 'flex-end' }}>
                                            {momData?.actionItems?.length + 1}
                                        </div>
                                    </td>
                                    <td style={{ borderRight: "1px solid #B8B8B8" }}>
                                        <div className="data date-data" >
                                            <textarea
                                                value={tablerow?.taskName}
                                                id="new-item"
                                                style={{
                                                    width: "100%",
                                                    outline: "none",
                                                    resize: "none",
                                                    minHeight: "34px",
                                                    boxShadow: "rgba(0, 0, 0, 0.16) 0px 1px 4px",
                                                    paddingTop: 7
                                                }}
                                                name="taskName"
                                                onChange={(e) =>
                                                    handleTaskNameChange({
                                                        event: e,
                                                        setTaskNameError,
                                                        handleAddRow,
                                                        tablerow,
                                                        setTablerow,
                                                        adjustTextareaHeightofNewItem,
                                                    })
                                                }
                                            />

                                        </div>
                                    </td>
                                    <td style={{ borderRight: "1px solid #B8B8B8" }}>
                                        <div className="data date-data owner-name-div"  >

                                            <div className='mainDiv-Items'>
                                                <span
                                                    data-testid="toggleMenu"
                                                    className='EPM-save-btn'
                                                    onClick={toggleMenu}
                                                >
                                                    Select Owner
                                                </span>
                                                {menuVisible && (
                                                    <div
                                                        ref={menuRef}
                                                        className='innerDiv-items'
                                                        data-testid="menuVisible"
                                                    >
                                                        {options.map(option => (
                                                            console.log("option",option),
                                                            <div key={option.emailId} data-testid="particulerDiv1" className='particulerDiv'>
                                                                <div className='optionsDiv-items '>
                                                                    <input
                                                                        type="checkbox"
                                                                        checked={tempCheckedValues.includes(option.emailId)}
                                                                        onChange={() => handleCheckboxChange(option, setTempCheckedValues, setTablerow, options, addNewActionItemClicked)}
                                                                        style={{ marginRight: '8px' }}
                                                                    />
                                                                    <span>
                                                                        {option.fullName}
                                                                    </span>
                                                                </div>
                                                            </div>
                                                        ))}
                                                    </div>
                                                )}
                                            </div>

                                        </div>
                                    </td>
                                    <td style={{ borderRight: "1px solid #B8B8B8" }}>
                                        <div className="data date-data" style={{ width: "85%", borderRadius: 5, marginBottom: 5, marginTop: 5, boxShadow: "rgba(0, 0, 0, 0.16) 0px 1px 4px", border: "1px solid #B8B8B8" }}>
                                            <svg id="calendar-line-icon" xmlns="http://www.w3.org/2000/svg" width="19.119px" height="15.122" viewBox="0 0 27.119 27.122"
                                            >
                                                <path id="Path_15922" data-name="Path 15922" d="M18.011,1.044A1.176,1.176,0,0,1,19.285,0a1.176,1.176,0,0,1,1.273,1.044V5.617a1.176,1.176,0,0,1-1.273,1.044,1.176,1.176,0,0,1-1.273-1.044V1.044ZM14.59,22.911c-.075,0-.135-.316-.135-.706s.06-.706.135-.706h3.485c.075,0,.135.316.135.706s-.06.706-.135.706ZM3.5,14.807c-.075,0-.135-.316-.135-.706s.06-.706.135-.706H6.983c.075,0,.135.316.135.706s-.06.706-.135.706Zm5.546,0c-.075,0-.135-.316-.135-.706s.06-.706.135-.706h3.485c.075,0,.135.316.135.706s-.06.706-.135.706Zm5.546,0c-.075,0-.135-.316-.135-.706s.06-.706.135-.706h3.485c.075,0,.135.316.135.706s-.06.706-.135.706Zm5.548,0c-.075,0-.135-.316-.135-.706s.06-.706.135-.706h3.485c.075,0,.135.316.135.706s-.06.706-.135.706ZM3.5,18.859c-.075,0-.135-.316-.135-.706s.06-.706.135-.706H6.983c.075,0,.135.316.135.706s-.06.706-.135.706Zm5.546,0c-.075,0-.135-.316-.135-.706s.06-.706.135-.706h3.485c.075,0,.135.316.135.706s-.06.706-.135.706Zm5.546,0c-.075,0-.135-.316-.135-.706s.06-.706.135-.706h3.485c.075,0,.135.316.135.706s-.06.706-.135.706Zm5.548,0c-.075,0-.135-.316-.135-.706s.06-.706.135-.706h3.485c.075,0,.135.316.135.706s-.06.706-.135.706ZM3.5,22.911c-.075,0-.135-.316-.135-.706s.06-.706.135-.706H6.983c.075,0,.135.316.135.706s-.06.706-.135.706Zm5.546,0c-.075,0-.135-.316-.135-.706s.06-.706.135-.706h3.485c.075,0,.135.316.135.706s-.06.706-.135.706ZM6.535,1.044A1.176,1.176,0,0,1,7.808,0,1.176,1.176,0,0,1,9.082,1.044V5.617A1.176,1.176,0,0,1,7.808,6.661,1.176,1.176,0,0,1,6.535,5.617V1.044ZM1.412,10H25.7V4.738a.652.652,0,0,0-.19-.457.644.644,0,0,0-.457-.19H22.732a.706.706,0,0,1,0-1.412H25.06a2.065,2.065,0,0,1,2.059,2.059V25.062a2.065,2.065,0,0,1-2.059,2.059h-23A2.065,2.065,0,0,1,0,25.06V4.738A2.065,2.065,0,0,1,2.059,2.679H4.546a.706.706,0,1,1,0,1.412H2.059a.652.652,0,0,0-.457.19.644.644,0,0,0-.19.457V10Zm24.294,1.415H1.412V25.06a.652.652,0,0,0,.19.457.644.644,0,0,0,.457.19h23a.652.652,0,0,0,.457-.19.644.644,0,0,0,.19-.457V11.417ZM11.13,4.092a.706.706,0,0,1,0-1.412h4.743a.706.706,0,0,1,0,1.412Z" fill="#00aff1"
                                                />
                                            </svg>
                                            <DatePicker
                                                selected={tablerow?.etaDate}
                                                value={tablerow?.etaDate}
                                                minDate={momData?.startDate}
                                                // minDate={today} // Minimum date selectable is today
                                                onChange={(date) => handleAddRow("etaDate", date, tablerow, setTablerow)}
                                                dateFormat="dd/MM/yyyy"

                                            />
                                        </div>
                                    </td>
                                    <td style={{ borderRight: "1px solid #B8B8B8" }}>
                                        <div className='EPM-date-Pickerr-cont' >
                                            <div className="data date-data" style={{ width: "85%", borderRadius: 5, marginBottom: 5, marginTop: 5, boxShadow: "rgba(0, 0, 0, 0.16) 0px 1px 4px", border: "1px solid #B8B8B8" }}>
                                                <svg id="calendar-line-icon" xmlns="http://www.w3.org/2000/svg" width="19.119px" height="15.122" viewBox="0 0 27.119 27.122"
                                                >
                                                    <path id="Path_15922" data-name="Path 15922" d="M18.011,1.044A1.176,1.176,0,0,1,19.285,0a1.176,1.176,0,0,1,1.273,1.044V5.617a1.176,1.176,0,0,1-1.273,1.044,1.176,1.176,0,0,1-1.273-1.044V1.044ZM14.59,22.911c-.075,0-.135-.316-.135-.706s.06-.706.135-.706h3.485c.075,0,.135.316.135.706s-.06.706-.135.706ZM3.5,14.807c-.075,0-.135-.316-.135-.706s.06-.706.135-.706H6.983c.075,0,.135.316.135.706s-.06.706-.135.706Zm5.546,0c-.075,0-.135-.316-.135-.706s.06-.706.135-.706h3.485c.075,0,.135.316.135.706s-.06.706-.135.706Zm5.546,0c-.075,0-.135-.316-.135-.706s.06-.706.135-.706h3.485c.075,0,.135.316.135.706s-.06.706-.135.706Zm5.548,0c-.075,0-.135-.316-.135-.706s.06-.706.135-.706h3.485c.075,0,.135.316.135.706s-.06.706-.135.706ZM3.5,18.859c-.075,0-.135-.316-.135-.706s.06-.706.135-.706H6.983c.075,0,.135.316.135.706s-.06.706-.135.706Zm5.546,0c-.075,0-.135-.316-.135-.706s.06-.706.135-.706h3.485c.075,0,.135.316.135.706s-.06.706-.135.706Zm5.546,0c-.075,0-.135-.316-.135-.706s.06-.706.135-.706h3.485c.075,0,.135.316.135.706s-.06.706-.135.706Zm5.548,0c-.075,0-.135-.316-.135-.706s.06-.706.135-.706h3.485c.075,0,.135.316.135.706s-.06.706-.135.706ZM3.5,22.911c-.075,0-.135-.316-.135-.706s.06-.706.135-.706H6.983c.075,0,.135.316.135.706s-.06.706-.135.706Zm5.546,0c-.075,0-.135-.316-.135-.706s.06-.706.135-.706h3.485c.075,0,.135.316.135.706s-.06.706-.135.706ZM6.535,1.044A1.176,1.176,0,0,1,7.808,0,1.176,1.176,0,0,1,9.082,1.044V5.617A1.176,1.176,0,0,1,7.808,6.661,1.176,1.176,0,0,1,6.535,5.617V1.044ZM1.412,10H25.7V4.738a.652.652,0,0,0-.19-.457.644.644,0,0,0-.457-.19H22.732a.706.706,0,0,1,0-1.412H25.06a2.065,2.065,0,0,1,2.059,2.059V25.062a2.065,2.065,0,0,1-2.059,2.059h-23A2.065,2.065,0,0,1,0,25.06V4.738A2.065,2.065,0,0,1,2.059,2.679H4.546a.706.706,0,1,1,0,1.412H2.059a.652.652,0,0,0-.457.19.644.644,0,0,0-.19.457V10Zm24.294,1.415H1.412V25.06a.652.652,0,0,0,.19.457.644.644,0,0,0,.457.19h23a.652.652,0,0,0,.457-.19.644.644,0,0,0,.19-.457V11.417ZM11.13,4.092a.706.706,0,0,1,0-1.412h4.743a.706.706,0,0,1,0,1.412Z" fill="#00aff1"
                                                    />
                                                </svg>
                                                <DatePicker
                                                    selected={tablerow?.closingDate}
                                                    value={tablerow?.closingDate}
                                                    onChange={(date) => handleAddRow("closingDate", date, tablerow, setTablerow)}
                                                    dateFormat="dd/MM/yyyy"
                                                    minDate={momData?.startDate} // Minimum date selectable is today
                                                    // maxDate={today} // Maximum date selectable is today
                                                    disabled={!tablerow?.etaDate}
                                                />
                                            </div>
                                        </div>
                                    </td>
                                    <td>
                                        <div style={{ display: 'flex', alignContent: 'center', justifyContent: 'center', gap: '5px' }}>
                                            <AiOutlinePlus fill="#00CEFF" size={'22px'} style={{ cursor: 'pointer', }} data-testid="AiOutlinePlus" onClick={() => { validateInput("actionItems", tablerow, setFormErrors, handleChange, tablerow); setTempCheckedValues([]) }} />
                                            {!(momData?.actionItems.length == 0) && <AiOutlineClose fill="#00CEFF" size={'20px'} style={{ cursor: 'pointer', marginTop: "2px" }} onClick={() => {
                                                setAddNewActionItemClicked(false);
                                                setTablerow({
                                                    "actionItemId": null,
                                                    "taskName": "",
                                                    "ownerName": "",
                                                    "etaDate": "",
                                                    "closingDate": "",
                                                    "assignedTo": null,
                                                    "assignedToList": []
                                                });
                                                setTempCheckedValues([])
                                            }} />}
                                        </div>
                                    </td>
                                </tr>}

                            </tbody>
                        </table>
                        {TaskNameError?.errorstatus && <div className='form-error field-containerr'>{TaskNameError?.errormsg}</div>}
                        {!TaskNameError?.errorstatus &&
                            formErrors?.actionItems && <div className='form-error field-containerr'>{formErrors?.actionItems}</div>
                        }
                    </div>
                </div>
                <div className="field-container EPM-save-btn-cont">
                    <button type='submit' data-testid="EPMsavebtnid" className='EPM-save-btn'>Save</button>
                </div>
            </form >
            {/* ----------------------------------------------------------------------Controll Ref Modal Close----------------------------------------------------------------------- */}
            < SuccessModal
                openSuccessModal={openSuccessModal}
                setOpenSuccessModal={setOpenSuccessModal}
                successMessage={successMessage}
                setSuccessMessage={setSuccessMessage}
                recallFunctionOnOk={navigateAfterSubmit}
                recallFunctionOnClose={navigateAfterSubmit}
            />
            <FailModal
                openFailModal={openFailModal}
                setOpenFailModal={setOpenFailModal}
                failMessage={failMessage}
                setFailMessage={setFailMessage}
                recallFunctionOnOk={handleCloseFailModel}
                recallFunctiononClose={handleCloseFailModel}
            />

            {/* session expire modal  */}
            <FailModal
                openFailModal={sessionExpiredModal}
                setOpenFailModal={setSessionExpiredModal}
                failMessage={failMessage}
                setFailMessage={setFailMessage}
                recallFunctionOnOk={()=>handleSessionExpClose(navigate,setActive)}
                recallFunctiononClose={()=>handleSessionExpClose(navigate,setActive)}
            />
        </div >
    )
}

export default EditPastMeeting